function injectStyle (ssrContext) {
  require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-4537ef61\",\"scoped\":false,\"hasInlineConfig\":false}!stylus-loader?sourceMap!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./wordpressCredentialsModal.vue")
}
var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./wordpressCredentialsModal.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4537ef61\",\"hasScoped\":false}!./wordpressCredentialsModal.html"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/wordpressCredentialsModal/wordpressCredentialsModal.vue
// module id = 2757
// module chunks = 1